import Text from '@cartwhl/ui/base/Text';

export default function FilesListDragOverlay() {
  return (
    <Text variant="studio/title/xl" className="text-white">
      Drop files to upload
    </Text>
  );
}
